import {
  FETCH_WEBENQUIRY,
  FETCH_WEBENQUIRY_FAILURE,
  FETCH_WEBENQUIRY_SUCCESS,
  //
  ADD_WEBENQUIRY,
  ADD_WEBENQUIRY_SUCCESS,
  ADD_WEBENQUIRY_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  EDIT_WEBENQUIRY,
  EDIT_WEBENQUIRY_SUCCESS,
  EDIT_WEBENQUIRY_FAILURE,
  //
  DELETE_WEBENQ,
  DELETE_WEBENQ_SUCCESS,
  DELETE_WEBENQ_FAILURE,
  //
  CONVERT_LEAD,
  CONVERT_LEAD_SUCCESS,
  CONVERT_LEAD_FAILURE,
  //
  TOGGLE_CONVERT,
  //
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAILURE,
  //
  GET_TYPE_REPORT,
  GET_TYPE_REPORT_SUCCESS,
  GET_TYPE_REPORT_FAILURE,
  //
  GET_REF_REPORT,
  GET_REF_REPORT_SUCCESS,
  GET_REF_REPORT_FAILURE,
  //
  SET_REPORT,
  SET_DIGITAL_DATA,
  SET_RECOMM_DATA,
  SET_LOCAL_DATA,
  SET_ADVERT_DATA,
} from "./constants";

export const fetchWebEnquiry = (payload, onSuccess) => ({
  type: FETCH_WEBENQUIRY,
  payload,
  onSuccess,
});
export const fetchWebEnquirySuccess = (payload) => ({
  type: FETCH_WEBENQUIRY_SUCCESS,
  payload,
});
export const fetchWebEnquiryFailure = (payload) => ({
  type: FETCH_WEBENQUIRY_FAILURE,
  payload,
});

export const addWebEnquiry = (payload) => ({
  type: ADD_WEBENQUIRY,
  payload,
});
export const addWebEnquirySuccess = (payload) => ({
  type: ADD_WEBENQUIRY_SUCCESS,
  payload,
});
export const addWebEnquiryFailure = (payload) => ({
  type: ADD_WEBENQUIRY_FAILURE,
  payload,
});

export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});

export const editWebEnquiry = (payload) => ({
  type: EDIT_WEBENQUIRY,
  payload,
});
export const editWebEnquirySuccess = (payload) => ({
  type: EDIT_WEBENQUIRY_SUCCESS,
  payload,
});
export const editWebEnquiryFailure = (payload) => ({
  type: EDIT_WEBENQUIRY_FAILURE,
  payload,
});

export const deleteWebEnquiry = (payload, onDeleteSuccess) => ({
  type: DELETE_WEBENQ,
  payload,
  onDeleteSuccess,
});
export const deleteWebEnquirySuccess = (payload) => ({
  type: DELETE_WEBENQ_SUCCESS,
  payload,
});
export const deleteWebEnquiryFailure = (payload) => ({
  type: DELETE_WEBENQ_FAILURE,
  payload,
});

export const convertLead = (payload, onSuccess) => ({
  type: CONVERT_LEAD,
  payload,
  onSuccess,
});
export const convertLeadSuccess = (payload) => ({
  type: CONVERT_LEAD_SUCCESS,
  payload,
});
export const convertLeadFailure = (payload) => ({
  type: CONVERT_LEAD_FAILURE,
  payload,
});

export const toggleConvert = (payload) => ({
  type: TOGGLE_CONVERT,
  payload,
});

export const getReport = (payload) => ({
  type: GET_REPORT,
  payload,
});
export const getReportSuccess = (payload) => ({
  type: GET_REPORT_SUCCESS,
  payload,
});
export const getReportFailure = (payload) => ({
  type: GET_REPORT_FAILURE,
  payload,
});

export const getTypeReport = (payload) => ({
  type: GET_TYPE_REPORT,
  payload,
});
export const getTypeReportSuccess = (payload) => ({
  type: GET_TYPE_REPORT_SUCCESS,
  payload,
});
export const getTypeReportFailure = (payload) => ({
  type: GET_TYPE_REPORT_FAILURE,
  payload,
});

export const getRefReport = (payload) => ({
  type: GET_REF_REPORT,
  payload,
});
export const getRefReportSuccess = (payload) => ({
  type: GET_REF_REPORT_SUCCESS,
  payload,
});
export const getRefReportFailure = (payload) => ({
  type: GET_REF_REPORT_FAILURE,
  payload,
});

export const setReport = (payload) => ({
  type: SET_REPORT,
  payload,
});

export const setDigitalData = (payload) => ({
  type: SET_DIGITAL_DATA,
  payload,
});
export const setRecommData = (payload) => ({
  type: SET_RECOMM_DATA,
  payload,
});
export const setLocalData = (payload) => ({
  type: SET_LOCAL_DATA,
  payload,
});
export const setAdvertData = (payload) => ({
  type: SET_ADVERT_DATA,
  payload,
});
